import { render, staticRenderFns } from "./Ankle.vue?vue&type=template&id=55aabc76&"
import script from "./Ankle.vue?vue&type=script&lang=js&"
export * from "./Ankle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports